import React from "react";
import "./abhaMobileFilter.scss";
import useDisableHelp from "../../../../Hooks/useDisableHelp";
import SearchBarWithIcon from "../../../common/Modules/SearchBarWithIcon";
import { HEADERLIST } from "../../../DashboardAppointmentsView/Constant";

export default function AbhaMobileFilter(props) {
  const {
    searchString,
    showMobileFilter,
    menuList,
    selectedMenu,
    handleClose,
    openMobileMenuList,
    selectMobileFilterOptions,
    handleApplyFilter,
    handleResetAllFilter,
    handleFilterSearch,
    placeholderForSearch,
  } = props;

  useDisableHelp();

  // lifecycle methods ==>

  //<====

  // Create UI ==>
  const renderMenuHeader = () => {
    return (
      <div className={`appointment-filter-body-sidebar-div col-sm-6 p-0`}>
        {menuList.map((header, ind) => (
          <div
            key={ind}
            className={
              "menu-title " + (header.show_filter ? "selected-menu-title" : "")
            }
            onClick={() => openMobileMenuList(header)}
          >
            {header.mobileFilterTitle}
          </div>
        ))}
      </div>
    );
  };

  const renderMenuList = () => {

    const filteredMenuData = selectedMenu?.menuData.filter(menu =>
      menu.name.toString().toLowerCase().includes(searchString.toLowerCase())
    );

    return (
      <>
        <div className="col-sm-6" style={{ overflowY: "auto" }}>
          {selectedMenu?.show_filter_searchbar && (
            <div className="py-2">
              <SearchBarWithIcon
                inputCallBack={handleFilterSearch}
                placeholder={placeholderForSearch}
                isClearable={true}
              />
            </div>
          )}
          {filteredMenuData?.map((menu, indM) => (
            <div
              key={indM}
              className="appointment-filter-body-right-div"
              onClick={() => {
                selectMobileFilterOptions(menu);
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <i
                    className={`fa fa-check mr-1 check-icon-filter ${
                      selectedMenu?.isMultiSelect
                        ? menu.selected
                          ? "activeTab"
                          : "inactiveTab"
                        : menu.selected
                        ? "activeTab"
                        : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                </div>
                <div>
                  {selectedMenu.title === HEADERLIST.PRESCRIPTION && /// to show prescription + prescription_status in mobile device only
                  menu.name.includes("Prescription")
                    ? menu.name.replace("Prescription", "")
                    : menu.name}
                </div>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  const renderFilterContent = () => {
    return (
      <div className="appointment-filter-body-div d-flex">
        {renderMenuHeader()}
        {renderMenuList()}
      </div>
    );
  };

  const renderFilterHeader = () => {
    return (
      <div className="d-flex col-sm-12 d-lg-none abha-filter-header-div">
        <div className="appointment-filter-header-tittle-div">Filters</div>
        <div className="ml-auto" onClick={handleClose}>
          Close
          <i className="fa fa-close pl-1" aria-hidden="true"></i>
        </div>
      </div>
    );
  };

  const renderFilterFooter = () => {
    return (
      <div className="d-flex col-sm-12 appointment-date-range-buttons-div p-2">
        <button
          className="ml-auto appointment-date-range-reset"
          onClick={handleResetAllFilter}
        >
          Reset All
        </button>
        <button
          className="ml-2 btn-primary appointment-date-range-apply"
          onClick={() => {
            handleApplyFilter();
          }}
        >
          Apply
        </button>
      </div>
    );
  };

  const renderFilterModal = () => {
    return (
      showMobileFilter && (
        <div className="abha-mobile-filter">
          {renderFilterHeader()}
          {renderFilterContent()}
          {renderFilterFooter()}
        </div>
      )
    );
  };

  //<=====
  return renderFilterModal();
}
